import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { DraftOutline12Icon, LockGlyph24Icon } from 'assets/icons'
import privacyConstants from 'config/constants/privacy'

const InitiativePrivacyBadge = ({ privacy }) => {
   if (['custom', 'inherit'].includes(privacy)) {
      return null
   }

   const currentPrivacyOption = privacyConstants.find(option => option.value === privacy)

   return (
      <View
         float="left"
         display="inline-flex"
         alignItems="center"
         height="15px"
         marginTop="1px"
         borderRadius="3px"
         marginRight="5px">
         <View marginBottom="2px" marginRight="4px">
            {privacy !== 'draft' && (
               <LockGlyph24Icon
                  width="12px"
                  height="12px"
                  color="#888"
               />
            )}
            {privacy === 'draft' && (
               <DraftOutline12Icon
                  width="10px"
                  height="10px"
                  color="#cf9738"
               />
            )}
         </View>
         <Text
            size="1"
            weight="medium"
            color={privacy === 'draft' ? '#cf9738' : '#888'}>
            {`${currentPrivacyOption.name}  ·  `}
         </Text>
      </View>
   )
}

InitiativePrivacyBadge.propTypes = {
   privacy: PropTypes.string.isRequired
}

export default InitiativePrivacyBadge
